// extracted by mini-css-extract-plugin
export default {"cards":"BookCard_cards__bI+Tx","container":"BookCard_container__8ynrd","card":"BookCard_card__8mV8c","name":"BookCard_name__hJmW9","image":"BookCard_image__aJdx8"};